import { z } from 'zod';

export const projectFormSchema = z.object({
    nameTH: z.string().nonempty({ message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }),
    nameEN: z.string().nonempty({ message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }),
    quantity: z.string().regex(/^\d+$/, { message: 'กรุณากรอกเฉพาะตัวเลข' }),
    price: z.string().nonempty({ message: 'กรุณากรอกข้อมูลให้ครบถ้วน' }).regex(/^\d+$/, { message: 'กรุณากรอกเฉพาะตัวเลข' }),
});
export type ProjectFormInput = z.infer<typeof projectFormSchema>;
